var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaIconEmailNobg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.67 80.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.84,37.3L101.45.7c-.94-.44-1.99-.7-3.09-.7H7.32c-1.1,0-2.15.25-3.09.7l48.61,36.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.89,34.1L.07,6.37c-.04.31-.07.63-.07.95v61.04l36.89-34.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.67,68.35V7.32c0-.32-.03-.64-.07-.95l-36.82,27.72,36.89,34.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.08,38.39l-8.11,6.11c-.11.08-.22.14-.33.2-.02.01-.04.03-.07.04-.17.1-.34.17-.52.24-.04.02-.08.03-.12.04-.16.05-.32.09-.48.11-.08.01-.15.03-.23.03-.12.01-.25.02-.37.02-.12,0-.25,0-.37-.02-.08,0-.15-.02-.23-.03-.16-.03-.32-.06-.48-.11-.04-.01-.08-.03-.12-.04-.18-.06-.35-.14-.52-.24-.02-.01-.04-.03-.07-.04-.11-.07-.23-.12-.33-.2l-8.11-6.11L1.07,76.96c1.29,2.11,3.61,3.54,6.25,3.54h91.04c2.64,0,4.96-1.42,6.25-3.54l-41.53-38.57Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIconEmailNobg);
export default __webpack_public_path__ + "static/media/Social_Media_Icon_Email_nobg.21a91d57d5153174a5a58257a05bfcd1.svg";
export { ForwardRef as ReactComponent };